<agpr-take-over-panel
    [id]="id"
    class="agpr-manageMentionOrganizationDialog"
    header="Mention.manageMentionOrganization"
    [overlayContainer]="overlayContainer"
    [hideSlideOverlay]="hideSlideOverlay"
    [animationTrigger]="animationTrigger"
    (visibleChange)="handleVisibleChange()"
    [minPanelWidth]="900"
    [maxPanelWidth]="1200"
    [responsiveWidth]="true"
>
    <div
        class="agpr-manageMentionOrganizationDialog-wrapper"
        [agprLoading]="loading"
    >
        <div class="agpr-manageMentionOrganizationDialog-lhp">
            <agpr-tabs
                [id]="id + '_tabs'"
                class="agpr-manageMentionOrganizationDialog-tabs"
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="selectedTabIndex = $event"
            >
                <agpr-tab
                    [id]="id + '_tagsTab'"
                    class="agpr-manageMentionOrganizationDialog-tab"
                    heading="Mention.manageMentionOrganization.tags"
                >
                    <div class="agpr-manageMentionOrganizationDialog-tabHeader">
                        <agpr-autocomplete
                            #tagAutocomplete
                            [id]="id + '_tagsAutocomplete'"
                            class="agpr-manageMentionOrganizationDialog-autocomplete"
                            labelField="name"
                            [ariaLabel]="'Mention.manageMentionOrganization.searchTags'"
                            placeholder="Mention.manageMentionOrganization.searchTags.placeholder"
                            (searchStringChanged)="filterTableRows(manageMentionOrganizationEnum.tag, $event)"
                            (clear)="resetTableRows(manageMentionOrganizationEnum.tag)"
                            [customOptions]="tagsAutocompleteOptions"
                            [clearOnBlur]="false"
                        ></agpr-autocomplete>
                        <agpr-button
                            class="agpr-manageMentionOrganizationDialog-createButton"
                            [style]="buttonTypesEnum.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="Mention.manageMentionOrganization.button.createTag"
                            (click)="onpenCreateTagDialog()"
                        ></agpr-button>
                    </div>
                    <agpr-table
                        #tagsTable
                        [id]="id + '_tagsTable'"
                        class="agpr-manageMentionOrganizationDialog-table"
                        [columns]="columnDefs"
                        [sortColumn]="nameColumn"
                        [showDelete]="false"
                        [sortAscending]="true"
                        [(ngModel)]="tagFilteredRows"
                        (itemChanged)="selectionChanged(manageMentionOrganizationEnum.tag, $event)"
                        (allSelectedChanged)="allSelectionChanged(manageMentionOrganizationEnum.tag, $event)"
                        [vsItemSize]="36"
                        [vsMinBufferPx]="1500"
                        [vsMaxBufferPx]="1500"
                    ></agpr-table>
                </agpr-tab>
                <agpr-tab
                    [id]="id + '_foldersTab'"
                    class="agpr-manageMentionOrganizationDialog-tab"
                    heading="Mention.manageMentionOrganization.folders"
                >
                    <div class="agpr-manageMentionOrganizationDialog-tabHeader">
                        <agpr-autocomplete
                            #folderAutocomplete
                            [id]="id + '_folderAutocomplete'"
                            class="agpr-manageMentionOrganizationDialog-autocomplete"
                            labelField="name"
                            [ariaLabel]="'Mention.manageMentionOrganization.searchFolderss'"
                            placeholder="Mention.manageMentionOrganization.searchFolders.placeholder"
                            (searchStringChanged)="filterTableRows(manageMentionOrganizationEnum.folder, $event)"
                            (clear)="resetTableRows(manageMentionOrganizationEnum.folder)"
                            [customOptions]="foldersAutocompleteOptions"
                            [clearOnBlur]="false"
                        ></agpr-autocomplete>
                        <agpr-button
                            class="agpr-manageMentionOrganizationDialog-createButton"
                            [style]="buttonTypesEnum.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="Mention.manageMentionOrganization.button.createFolder"
                            (click)="onpenCreateFolderDialog()"
                        ></agpr-button>
                    </div>
                    <agpr-table
                        #foldersTable
                        [id]="id + '_foldersTable'"
                        class="agpr-manageMentionOrganizationDialog-table"
                        [columns]="columnDefs"
                        [sortColumn]="nameColumn"
                        [showDelete]="false"
                        [sortAscending]="true"
                        [(ngModel)]="folderFilteredRows"
                        (itemChanged)="selectionChanged(manageMentionOrganizationEnum.folder, $event)"
                        (allSelectedChanged)="allSelectionChanged(manageMentionOrganizationEnum.folder, $event)"
                        [vsItemSize]="36"
                        [vsMinBufferPx]="1500"
                        [vsMaxBufferPx]="1500"
                    ></agpr-table>
                </agpr-tab>
            </agpr-tabs>
        </div>

        <div class="agpr-manageMentionOrganizationDialog-rhp">
            <div class="agpr-manageMentionOrganizationDialog-mentionWrapper">
                <agpr-mention-card
                    [id]="id + '_mention'"
                    class="agpr-manageMentionOrganizationDialog-mention"
                    [mention]="_mention"
                    [mentionSearch]="search"
                    [badges]="mentionBadgesSaved"
                    [mentionContent]="mentionContentCustomizationEnum.summary"
                    [showPublishedDate]="true"
                ></agpr-mention-card>
            </div>
            <agpr-scroll-panel class="agpr-manageMentionOrganizationDialog-scrollWrapper">
                @if(tagChips.length === 0 && folderChips.length === 0) {
                    <agpr-message
                        [id]="id + '_noContentMessage'"
                        class="agpr-manageMentionOrganizationDialog-message"
                        [severity]="messageSeverityEnum.noContent"
                        [bottomMargin]="false"
                    >
                        {{ 'Mention.manageMentionOrganization.noContentMessage' | localize }}
                    </agpr-message>
                } @else {
                    @if(tagChips.length > 0) {
                        <div class="agpr-manageMentionOrganizationDialog-chipWrapper">
                            <div class="agpr-manageMentionOrganizationDialog-chipHeader">
                                <span>
                                    {{ 'Mention.manageMentionOrganization.tags' | localize }}
                                </span>
                                <agpr-button
                                    class="agpr-manageMentionOrganizationDialog-chipHeader-removeAllButton"
                                    [style]="buttonTypesEnum.icon"
                                    icon="fa-regular fa-square-xmark"
                                    tooltip="Mention.manageMentionOrganization.removeAllTags"
                                    (click)="removeAllChips(manageMentionOrganizationEnum.tag)"
                                ></agpr-button>
                            </div>
                            <agpr-chip-container
                                class="agpr-manageMentionOrganizationDialog-chipContainer"
                                [id]="id + '_tagChipContainer'"
                                [chips]="tagChips"
                                [plainMode]="true"
                                (removeChip)="removeChip(manageMentionOrganizationEnum.tag, $event)"
                            ></agpr-chip-container>
                        </div>
                    }
                    @if(folderChips.length > 0) {
                        <div class="agpr-manageMentionOrganizationDialog-chipWrapper">
                            <div class="agpr-manageMentionOrganizationDialog-chipHeader">
                                <span>
                                    {{ 'Mention.manageMentionOrganization.folders' | localize }}
                                </span>
                                <agpr-button
                                    class="agpr-manageMentionOrganizationDialog-chipHeader-removeAllButton"
                                    [style]="buttonTypesEnum.icon"
                                    icon="fa-regular fa-square-xmark"
                                    tooltip="Mention.manageMentionOrganization.removeAllFolders"
                                    (click)="removeAllChips(manageMentionOrganizationEnum.folder)"
                                ></agpr-button>
                            </div>
                            <agpr-chip-container
                                class="agpr-manageMentionOrganizationDialog-chipContainer"
                                [id]="id + '_folderChipContainer'"
                                [chips]="folderChips"
                                [plainMode]="true"
                                (removeChip)="removeChip(manageMentionOrganizationEnum.folder, $event)"
                            ></agpr-chip-container>
                        </div>
                    }
                }
                @if(addedTags.length > 0
                    || removedTags.length > 0
                    || addedFolders.length > 0
                    || removedFolders.length > 0) {
                    <agpr-message
                        [id]="id + '_infoMessage'"
                        class="agpr-manageMentionOrganizationDialog-message"
                        [severity]="messageSeverityEnum.info"
                        [bottomMargin]="false"
                    >
                        @if(addedFolders.length > 0) {
                            <div class="agpr-manageMentionOrganizationDialog-messageHeader">
                                {{ 'Mention.manageMentionOrganization.infoMessage.addToFolders' | localize }}
                            </div>
                            @for(item of addedFolders; track item.id) {
                                <span>
                                    {{ item.name + (!first && !$last ? ', ' : '') }}
                                </span>
                            }
                        }
                        @if(removedFolders.length > 0) {
                            <div class="agpr-manageMentionOrganizationDialog-messageHeader">
                                {{ 'Mention.manageMentionOrganization.infoMessage.removeFromFolders' | localize }}
                            </div>
                            @for(item of removedFolders; track item.id) {
                                <span>
                                    {{ item.name + (!first && !$last ? ', ' : '') }}
                                </span>
                            }
                        }
                        @if(addedTags.length > 0) {
                            <div class="agpr-manageMentionOrganizationDialog-messageHeader">
                                {{ 'Mention.manageMentionOrganization.infoMessage.addTags' | localize }}
                            </div>
                            @for(item of addedTags; track item.id) {
                                <span>
                                    {{ item.name + (!first && !$last ? ', ' : '') }}
                                </span>
                            }
                        }
                        @if(removedTags.length > 0) {
                            <div class="agpr-manageMentionOrganizationDialog-messageHeader">
                                {{ 'Mention.manageMentionOrganization.infoMessage.removeTags' | localize }}
                            </div>
                            @for(item of removedTags; track item.id) {
                                <span>
                                    {{ item.name + (!first && !$last ? ', ' : '') }}
                                </span>
                            }
                        }
                    </agpr-message>
                }
            </agpr-scroll-panel>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Core.button.cancel"
            [style]="buttonTypesEnum.secondary"
            (click)="cancel()"
        ></agpr-button>
        <agpr-button
            [style]="buttonTypesEnum.secondary"
            label="Mention.manageMentionOrganization.button.removeFromAccount"
            [disabled]="!_mention?.mentionId"
            (click)="removeFromAccount()"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [style]="buttonTypesEnum.primary"
            label="Mention.manageMentionOrganization.button.updateMention"
            [disabled]="addedTags.length === 0
                && removedTags.length === 0
                && addedFolders.length === 0
                && removedFolders.length === 0"
            (click)="updateMention()"
            [agprLoading]="loading"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
